import { createFileRoute } from "@tanstack/react-router";
import CasosExito from "@/pages/CasosExito";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";
import { projectCases } from "@/data/project-cases";

const canonicalUrl = "https://agenciaseoevolution.com/casos-exito";

const breadcrumbSchema = buildBreadcrumb([{ name: "Casos de éxito", path: "/casos-exito" }]);
const title = "Casos reales de SEO, IA y desarrollo web | SEOEVOLUTION";
const description = "Herrolex, La Sagra, ITV Máquinas de Hielo y Barbers Roldán: trabajo realizado, alcance y resultados documentados de SEO, IA y desarrollo web.";
const casesSchema = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  name: title,
  description,
  url: canonicalUrl,
  mainEntity: {
    "@type": "ItemList",
    itemListElement: projectCases.map((project, index) => ({
      "@type": "ListItem",
      position: index + 1,
      item: { "@type": "CreativeWork", name: project.title, description: `${project.summary} ${project.context}`, url: `${canonicalUrl}#${project.id}` },
    })),
  },
};

export const Route = createFileRoute("/casos-exito")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonicalUrl },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: canonicalUrl }],
    scripts: [ldJson(breadcrumbSchema), ldJson(casesSchema)],
  }),
  component: CasosExito,
});
